module.exports = __webpack_public_path__ + "static/media/besties-coke.660347fa.svg";